<script>
import Encoding from 'encoding-japanese'
import SettingGroup from '../../layout/SettingGroup.vue'
import SettingItem from '../../layout/SettingItem.vue'
import CheckboxGroup from '@/components/pc/radio/ipradio/atoms/CheckboxGroup.vue'
import FormTextBox from '@/components/pc/radio/ipradio/atoms/FormTextBox.vue'
import RadioGroup from '@/components/pc/radio/ipradio/atoms/RadioGroup.vue'
import RangeSlider from '@/components/pc/radio/ipradio/atoms/RangeSlider.vue'
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import { BC, BC_TRANS_JP } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
    name: 'EmergencySettingsVue2',
    components: {
        SettingGroup,
        SettingItem,
        CheckboxGroup,
        FormTextBox,
        RadioGroup,
        RangeSlider,
        SelectBox,
        ToggleSwitch,
    },

    data() {
        // ストア
        const radioSettings = useRadioSettingsStore()

        // ==== 各種オプション ====
        const radioBtnOptions = {
            emergencyModeType: Object.keys(BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_MODE_TYPE).map(
                (key) => ({
                    label: BC_TRANS_JP.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_MODE_TYPE[key],
                    value: BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_MODE_TYPE[key],
                }),
            ),
            emergencyDisplay: Object.keys(BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY).map(
                (key) => ({
                    label: BC_TRANS_JP.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY[key],
                    value: BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY[key],
                }),
            ),
            loneWorkerType: Object.keys(
                BC.EMERGENCY_INFORMATION.EMERGENCY.LONE_WORKER.LONE_WORKER_TYPE,
            ).map((key) => ({
                label: BC_TRANS_JP.EMERGENCY_INFORMATION.EMERGENCY.LONE_WORKER.LONE_WORKER_TYPE[key],
                value: BC.EMERGENCY_INFORMATION.EMERGENCY.LONE_WORKER.LONE_WORKER_TYPE[key],
            })),
        }

        const selectboxOptions = {
            manDownAngle: BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MAN_DOWN_ANGLE.map(
                (value) => ({
                    label: `${value} 度`,
                    value: String(value),
                }),
            ),
        }

        const checkboxOptions = [
            {
                label: BC_TRANS_JP.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE.INFINITE,
                value: BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE.INFINITE,
            },
        ]

        const detectionRangeOptions = [
            {
                prefix: 'manDown',
                toggleDetection: 'manDownDetection',
                toggleDelay: 'manDownDelayTime',
                rangeDelay: 'manDownDelayTimeValue',
                togglePreAlert: 'manDownPreAlert',
                rangePreAlert: 'manDownPreAlertValue',
            },
            {
                prefix: 'stationary',
                toggleDetection: 'stationaryDetection',
                toggleDelay: 'stationaryDelayTime',
                rangeDelay: 'stationaryDelayTimeValue',
                togglePreAlert: 'stationaryPreAlert',
                rangePreAlert: 'stationaryPreAlertValue',
            },
            {
                prefix: 'motion',
                toggleDetection: 'motionDetection',
                toggleDelay: 'motionDelayTime',
                rangeDelay: 'motionDelayTimeValue',
                togglePreAlert: 'motionPreAlert',
                rangePreAlert: 'motionPreAlertValue',
            },
        ]

        // ==== フォーム ====
        const form = {
            radioBtn: {
                emergencyModeType: radioBtnOptions.emergencyModeType[0].value,
                emergencyDisplay: radioBtnOptions.emergencyDisplay[0].value,
                loneWorkerType: radioBtnOptions.loneWorkerType[0].value,
            },
            selectbox: {
                manDownAngle: selectboxOptions.manDownAngle[0].value,
            },
            toggle: {
                emergencyCycle: false,
                emergencyLED: false,
                backgroundToneTransmission: false,
                emergencyStopRequest: false,
                durationLoneWorkerTone: false,
                manDownDetection: false,
                manDownWithStationary: false,
                manDownDelayTime: false,
                manDownPreAlert: false,
                stationaryDetection: false,
                stationaryDelayTime: false,
                stationaryPreAlert: false,
                motionDetection: false,
                motionDelayTime: false,
                motionPreAlert: false,
            },
            text: {
                emergencyText: null,
                prevEmergencyText: null,
            },
            checkbox: {
                emergencyCycleInfinite: [],
            },
            range: {
                emergencyCycleValue: 0,
                durationLocatorTone: 0,
                transmitDuration: 0,
                loneWorkerInterval: 0,
                durationLoneWorkerToneValue: 0,
                manDownDelayTimeValue: 0,
                manDownPreAlertValue: 0,
                stationaryDelayTimeValue: 0,
                stationaryPreAlertValue: 0,
                motionDelayTimeValue: 0,
                motionPreAlertValue: 0,
            },
        }

        // 設定オブジェクト（ストアから仮保存を取得）
        const setting = radioSettings.getTempSetting()

        return {
            // stores
            radioSettings,
            // options
            radioBtnOptions,
            selectboxOptions,
            checkboxOptions,
            detectionRangeOptions,
            // state
            form,
            setting,
            // el-form rules（createdで validator を差し込む）
            rules: {},
        }
    },

    computed: {
        BC() {
            return BC
        },
        BC_TRANS_JP() {
            return BC_TRANS_JP
        }
    },

    created() {
        // 初期同期
        this.transSetting2Form()

        // el-form の rules（this を使うので created で設定）
        this.rules = {
            emergencyText: [
                {
                    validator: this.validateEmergencyText,
                    trigger: 'change',
                },
            ],
        }

        // ---- 全体の deep watch（フォーム -> 設定へ）----
        this.$watch(
            'form',
            () => {
                this.transForm2Setting()
                this.radioSettings.saveTempSetting(this.setting)
            },
            { deep: true },
        )

        // ---- 個別 watch ----
        this.$watch(
            () => this.form.toggle.emergencyCycle,
            (newVal) => {
                if (!newVal) this.form.checkbox.emergencyCycleInfinite = []
            },
        )
        this.$watch(
            () => this.form.radioBtn.emergencyDisplay,
            (newVal, oldVal) => {
                // TEXT から離れるときは現在値を退避して保持
                if (
                    oldVal === BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY.TEXT &&
                    newVal !== BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY.TEXT
                ) {
                    this.form.text.prevEmergencyText = this.form.text.emergencyText || ''
                }

                // TEXT に戻るときは退避していた値を復元（ただし空なら復元しない）
                if (
                    newVal === BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY.TEXT &&
                    oldVal !== BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY.TEXT
                ) {
                    if (!this.form.text.emergencyText) {
                        this.form.text.emergencyText = this.form.text.prevEmergencyText || ''
                    }
                }
            },
        )
        this.$watch(
            () => this.form.toggle.manDownDetection,
            (newVal) => {
                if (!newVal) this.form.toggle.manDownWithStationary = false
            },
        )
        this.$watch(
            () => this.form.toggle.manDownWithStationary,
            (newVal) => {
                if (newVal) this.form.toggle.stationaryDetection = false
            },
        )

        // detectionRangeOptions ごとの複合監視（Vue2は this.$watch に関数を渡して配列で返す）
        this.detectionRangeOptions.forEach((type) => {
            // 遅延トグルと値を同時監視
            this.$watch(
                () => [this.form.toggle[type.toggleDelay], this.form.range[type.rangeDelay]],
                ([delayEnable, delayValue]) => {
                    // 1. 遅延OFF or 1秒以下なら preAlert OFF
                    if (!delayEnable || delayValue <= 1) {
                        this.form.toggle[type.togglePreAlert] = false
                    }
                    // 2. preAlert が delay 以上なら delay を (preAlert+1) 以上に
                    if (delayValue <= this.form.range[type.rangePreAlert]) {
                        this.form.range[type.rangePreAlert] = Math.max(delayValue - 1, 0)
                    }
                },
                { deep: false },
            )

            // preAlert と delay の関係監視
            this.$watch(
                () => [this.form.range[type.rangePreAlert], this.form.range[type.rangeDelay]],
                ([preAlertValue, delayValue]) => {
                    if (delayValue > 1 && preAlertValue >= delayValue) {
                        this.form.range[type.rangeDelay] = preAlertValue + 1
                    }
                },
                { deep: false },
            )
        })
    },

    methods: {
        // SelectBox の更新
        handleSelectBox(value) {
            this.form.selectbox.manDownAngle = Number(value)
        },

        validateEmergencyText(rule, value, callback) {
            if (!value) return callback();


            // 定義
            const allowedKu = (ku) => (ku >= 1 && ku <= 8) || ku === 13 || (ku >= 16 && ku <= 84);

            const encodeSjis = (s) => Encoding.convert(Encoding.stringToCode(s), { to: 'SJIS', from: 'UNICODE', type: 'array' });

            const decodeSjis = (bytes) => Encoding.codeToString(Encoding.convert(bytes, { to: 'UNICODE', from: 'SJIS', type: 'array' }));

            const sjisToKuTen = (b1, b2) => {
                let j1 =
                (b1 >= 0x81 && b1 <= 0x9F) ? (b1 - 0x81) * 2 + 0x21 :
                (b1 >= 0xE0 && b1 <= 0xEF) ? (b1 - 0xC1) * 2 + 0x21 :
                null;
                if (j1 == null) return null;

                let j2;
                if (b2 >= 0x9F && b2 <= 0xFC) { j1 += 1; j2 = b2 - 0x7E; }
                else if (b2 >= 0x40 && b2 <= 0x7E) j2 = b2 - 0x1F;
                else if (b2 >= 0x80 && b2 <= 0x9E) j2 = b2 - 0x20;
                else return null;

                const ku = j1 - 0x20, ten = j2 - 0x20;
                return (ku >= 1 && ku <= 94 && ten >= 1 && ten <= 94) ? { ku, ten } : null;
            };
            // 定義


            // フィルタしつつ SJIS 換算14バイト以内で打ち切り
            let out = '';
            let used = 0;

            for (const ch of value) {
                const cp = ch.codePointAt(0);
                if (cp < 0x20 && ch !== ' ') continue;

                let bytes;
                try { bytes = encodeSjis(ch); } catch { continue; }
                if (!bytes || bytes.length < 1 || bytes.length > 2) continue;

                // 往復一致（置換・互換変換を排除）
                if (decodeSjis(bytes) !== ch) continue;

                if (bytes.length === 1) {
                const b = bytes[0];
                if (!((b >= 0x20 && b <= 0x7E) || (b >= 0xA1 && b <= 0xDF))) continue;
                } else {
                const kt = sjisToKuTen(bytes[0], bytes[1]);
                if (!kt || !allowedKu(kt.ku)) continue;
                }

                if (used + bytes.length > 14) break; // 元コード同様「入らない最初の文字」で打ち切り
                out += ch;
                used += bytes.length;
            }

            this.form.text.emergencyText = out;
            this.form.text.prevEmergencyText = this.form.text.emergencyText
            callback();
        },

        // フォーム -> 設定
        transForm2Setting() {
            const data = this.setting.EmergencyInformation.Emergency
            // console.log('============================')
            // console.log('before setting: ', JSON.parse(JSON.stringify(this.setting.EmergencyInformation.Emergency)))

            data.EmergencyModeType = this.form.radioBtn.emergencyModeType

            if (!this.form.toggle.emergencyCycle) {
                data.EmergencyCycle = BC.COMMON.TOGGLE.DISABLE
            } else if (
                this.form.toggle.emergencyCycle &&
                this.form.checkbox.emergencyCycleInfinite.includes(
                    BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE.INFINITE,
                )
            ) {
                data.EmergencyCycle = BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE.INFINITE
            } else {
                data.EmergencyCycle = BC.COMMON.TOGGLE.ENABLE
            }
            data.EmergencyCycleValue = this.form.range.emergencyCycleValue
            data.DurationLocatorTone = this.form.range.durationLocatorTone
            data.TransmitDuration = this.form.range.transmitDuration
            data.EmergencyDisplay = this.form.radioBtn.emergencyDisplay
            // 表示が TEXT 以外でも文字列は内部的に保持する
            // (TEXT 表示時にのみ画面上で有効になるが、設定データとしては保持し続ける)
            data.EmergencyText = this.form.text.emergencyText || null
            this.form.text.prevEmergencyText = this.form.text.emergencyText || ''
            data.EmergencyLED = this.form.toggle.emergencyLED
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.BackgroundToneTransmission = this.form.toggle.backgroundToneTransmission
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyStopRequest = this.form.toggle.emergencyStopRequest
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE

            data.LoneWorker.LoneWorkerType = this.form.radioBtn.loneWorkerType
            data.LoneWorker.LoneWorkerInterval = this.form.range.loneWorkerInterval
            data.LoneWorker.DurationLoneWorkerTone = this.form.toggle.durationLoneWorkerTone
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.LoneWorker.DurationLoneWorkerToneValue = this.form.range.durationLoneWorkerToneValue

            data.EmergencyDetection['Man-downDetection'] = this.form.toggle.manDownDetection
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection['Man-downWithStationary'] =
                this.form.toggle.manDownWithStationary ? BC.COMMON.TOGGLE.ENABLE : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection['Man-downAngle'] = this.form.selectbox.manDownAngle
            data.EmergencyDetection['Man-downDelayTime'] = this.form.toggle.manDownDelayTime
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection['Man-downDelayTimeValue'] =
                this.form.range.manDownDelayTimeValue
            data.EmergencyDetection['Man-downPre-alert'] = this.form.toggle.manDownPreAlert
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection['Man-downPre-alertValue'] =
                this.form.range.manDownPreAlertValue
            data.EmergencyDetection.StationaryDetection = this.form.toggle.stationaryDetection
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection.StationaryDelayTime = this.form.toggle.stationaryDelayTime
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection.StationaryDelayTimeValue =
                this.form.range.stationaryDelayTimeValue
            data.EmergencyDetection['StationaryPre-alert'] = this.form.toggle.stationaryPreAlert
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection['StationaryPre-alertValue'] =
                this.form.range.stationaryPreAlertValue
            data.EmergencyDetection.MotionDetection = this.form.toggle.motionDetection
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection.MotionDelayTime = this.form.toggle.motionDelayTime
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection.MotionDelayTimeValue = this.form.range.motionDelayTimeValue
            data.EmergencyDetection['MotionPre-alert'] = this.form.toggle.motionPreAlert
                ? BC.COMMON.TOGGLE.ENABLE
                : BC.COMMON.TOGGLE.DISABLE
            data.EmergencyDetection['MotionPre-alertValue'] =
                this.form.range.motionPreAlertValue

            // console.log('after setting: ', JSON.parse(JSON.stringify(this.setting.EmergencyInformation.Emergency)))
        },

        // 設定 -> フォーム
        transSetting2Form() {
            const data = this.setting.EmergencyInformation.Emergency
            // console.log('============================')
            // console.log('before form: ', JSON.parse(JSON.stringify(this.form)))

            this.form.radioBtn.emergencyModeType =
                data.EmergencyModeType || BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_MODE_TYPE.SILENT

            this.form.toggle.emergencyCycle =
                data.EmergencyCycle === BC.COMMON.TOGGLE.ENABLE ||
                data.EmergencyCycle === BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE.INFINITE
            this.form.checkbox.emergencyCycleInfinite =
                data.EmergencyCycle === BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE.INFINITE
                    ? [BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE.INFINITE]
                    : []

            this.form.range.emergencyCycleValue = data.EmergencyCycleValue
            this.form.range.durationLocatorTone = data.DurationLocatorTone
            this.form.range.transmitDuration = data.TransmitDuration

            this.form.radioBtn.emergencyDisplay =
                data.EmergencyDisplay ||
                BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY.SELECTED_GROUP
            this.form.text.emergencyText = data.EmergencyText
            this.form.text.prevEmergencyText = this.form.text.emergencyText || ''

            this.form.toggle.emergencyLED = data.EmergencyLED === BC.COMMON.TOGGLE.ENABLE
            this.form.toggle.backgroundToneTransmission =
                data.BackgroundToneTransmission === BC.COMMON.TOGGLE.ENABLE
            this.form.toggle.emergencyStopRequest =
                data.EmergencyStopRequest === BC.COMMON.TOGGLE.ENABLE

            this.form.radioBtn.loneWorkerType =
                data.LoneWorker.LoneWorkerType ||
                BC.EMERGENCY_INFORMATION.EMERGENCY.LONE_WORKER.LONE_WORKER_TYPE.NORMAL
            this.form.range.loneWorkerInterval = data.LoneWorker.LoneWorkerInterval
            this.form.toggle.durationLoneWorkerTone =
                data.LoneWorker.DurationLoneWorkerTone === BC.COMMON.TOGGLE.ENABLE
            this.form.range.durationLoneWorkerToneValue =
                data.LoneWorker.DurationLoneWorkerToneValue

            this.form.toggle.manDownDetection =
                data.EmergencyDetection['Man-downDetection'] === BC.COMMON.TOGGLE.ENABLE
            this.form.toggle.manDownWithStationary =
                data.EmergencyDetection['Man-downWithStationary'] === BC.COMMON.TOGGLE.ENABLE
            this.form.toggle.manDownDelayTime =
                data.EmergencyDetection['Man-downDelayTime'] === BC.COMMON.TOGGLE.ENABLE
            this.form.range.manDownDelayTimeValue =
                data.EmergencyDetection['Man-downDelayTimeValue']
            this.form.toggle.manDownPreAlert =
                data.EmergencyDetection['Man-downPre-alert'] === BC.COMMON.TOGGLE.ENABLE
            this.form.range.manDownPreAlertValue =
                data.EmergencyDetection['Man-downPre-alertValue']

            this.form.selectbox.manDownAngle = data.EmergencyDetection['Man-downAngle']
            this.form.toggle.stationaryDetection =
                data.EmergencyDetection.StationaryDetection === BC.COMMON.TOGGLE.ENABLE
            this.form.toggle.stationaryDelayTime =
                data.EmergencyDetection.StationaryDelayTime === BC.COMMON.TOGGLE.ENABLE
            this.form.range.stationaryDelayTimeValue =
                data.EmergencyDetection.StationaryDelayTimeValue
            this.form.toggle.stationaryPreAlert =
                data.EmergencyDetection['StationaryPre-alert'] === BC.COMMON.TOGGLE.ENABLE
            this.form.range.stationaryPreAlertValue =
                data.EmergencyDetection['StationaryPre-alertValue']

            this.form.toggle.motionDetection =
                data.EmergencyDetection.MotionDetection === BC.COMMON.TOGGLE.ENABLE
            this.form.toggle.motionDelayTime =
                data.EmergencyDetection.MotionDelayTime === BC.COMMON.TOGGLE.ENABLE
            this.form.range.motionDelayTimeValue =
                data.EmergencyDetection.MotionDelayTimeValue
            this.form.toggle.motionPreAlert =
                data.EmergencyDetection['MotionPre-alert'] === BC.COMMON.TOGGLE.ENABLE
            this.form.range.motionPreAlertValue =
                data.EmergencyDetection['MotionPre-alertValue']

            // console.log('after form: ', JSON.parse(JSON.stringify(this.form)))
        },
    },
}
</script>

<template>
    <div>
        <SettingGroup title="基本">
            <SettingItem label="エマージェンシーの種類">
                <RadioGroup
                    :value="form.radioBtn.emergencyModeType"
                    :options="radioBtnOptions.emergencyModeType"
                    :disable="false"
                    @input="val => (form.radioBtn.emergencyModeType = val)"
                />
            </SettingItem>

            <SettingItem label="エマージェンシー周期">
                <ToggleSwitch
                    v-model="form.toggle.emergencyCycle"
                    :disable="false"
                />
                <CheckboxGroup
                   :selectedItems="form.checkbox.emergencyCycleInfinite|| []"
                   :items="checkboxOptions"
                   :disabled="!form.toggle.emergencyCycle"
                   @update:selectedItems="val => (form.checkbox.emergencyCycleInfinite = val)"
                />
                <RangeSlider
                    :inputValue="form.range.emergencyCycleValue"
                    @update:inputValue="form.range.emergencyCycleValue = $event"
                    :disable="
                        !form.toggle.emergencyCycle ||
                        form.checkbox.emergencyCycleInfinite.includes(
                          BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE.INFINITE,
                        )
                      "
                    :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE_VALUE.MIN"
                    :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_CYCLE_VALUE.MAX"
                    unit="[回]"
                />
            </SettingItem>

            <SettingItem label="トーン送出時間">
                <RangeSlider
                    :inputValue="form.range.durationLocatorTone"
                    @update:inputValue="form.range.durationLocatorTone = $event"
                    :disable="
            form.radioBtn.emergencyModeType ===
            BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_MODE_TYPE.SILENT
          "
                    :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.DURATION_LOCATOR_TONE.MIN"
                    :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.DURATION_LOCATOR_TONE.MAX"
                    unit="[秒]"
                />
            </SettingItem>

            <SettingItem label="自動送信時間">
                <RangeSlider
                    :inputValue="form.range.transmitDuration"
                    @update:inputValue="form.range.transmitDuration = $event"
                    :disable="false"
                    :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.TRANSMIT_DURATION.MIN"
                    :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.TRANSMIT_DURATION.MAX"
                    unit="[秒]"
                />
            </SettingItem>

            <SettingItem label="エマージェンシー時の表示">
                <RadioGroup
                    :value="form.radioBtn.emergencyDisplay"
                    :options="radioBtnOptions.emergencyDisplay"
                    :disable="false"
                    @input="val => (form.radioBtn.emergencyDisplay = val)"
                />
            </SettingItem>

            <SettingItem label="文字列">
                <el-form :model="form.text" :rules="rules">
                    <FormTextBox
                        :input-value="form.text.emergencyText"
                        label=""
                        :disable="
              form.radioBtn.emergencyDisplay !==
              BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DISPLAY.TEXT
            "
                        :required="false"
                        placeholder="(半角14文字/全角7文字)"
                        prop="emergencyText"
                        @update:inputValue="val => form.text.emergencyText = val"
                    />
                </el-form>
            </SettingItem>

            <SettingItem label="エマージェンシー・モード解除要求">
                <ToggleSwitch
                    v-model="form.toggle.emergencyStopRequest"
                    :disable="false"
                />
            </SettingItem>
        </SettingGroup>

        <SettingGroup title="トーン/LED">
            <SettingItem label="LED">
                <ToggleSwitch
                    v-model="form.toggle.emergencyLED"
                    :disable="false"
                />
            </SettingItem>

            <SettingItem label="バックグラウンド・トーン">
                <ToggleSwitch
                    v-model="form.toggle.backgroundToneTransmission"
                    :disable="false"
                />
            </SettingItem>
        </SettingGroup>

        <SettingGroup title="定時確認（ローン・ワーカー）">
            <SettingItem label="定時確認（ローン・ワーカー）タイプ">
                <RadioGroup
                    :value="form.radioBtn.loneWorkerType"
                    :options="radioBtnOptions.loneWorkerType"
                    :disable="false"
                    @input="val => (form.radioBtn.loneWorkerType = val)"
                />
            </SettingItem>

            <SettingItem label="トーン送出の待機時間">
                <RangeSlider
                    :inputValue="form.range.loneWorkerInterval"
                    @update:inputValue="form.range.loneWorkerInterval = $event"
                    :disable="false"
                    :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.LONE_WORKER.LONE_WORKER_INTERVAL.MIN"
                    :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.LONE_WORKER.LONE_WORKER_INTERVAL.MAX"
                    unit="[分]"
                />
            </SettingItem>

            <SettingItem label="トーン送出時間">
                <ToggleSwitch
                    v-model="form.toggle.durationLoneWorkerTone"
                    :disable="false"
                />
                <RangeSlider
                    :inputValue="form.range.durationLoneWorkerToneValue"
                    @update:inputValue="form.range.durationLoneWorkerToneValue = $event"
                    :disable="!form.toggle.durationLoneWorkerTone"
                    :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.LONE_WORKER.DURATION_LONE_WORKER_TONE_VALUE.MIN"
                    :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.LONE_WORKER.DURATION_LONE_WORKER_TONE_VALUE.MAX"
                    unit="[秒]"
                />
            </SettingItem>
        </SettingGroup>

        <SettingGroup title="エマージェンシー検知">
            <SettingGroup title="転倒検知" :indent="1">
                <template v-slot:title-extra>
                    <span class="title-extra-space">
                        <ToggleSwitch
                            v-model="form.toggle.manDownDetection"
                            :disable="false"
                        />
                    </span>
                </template>

                <SettingGroup :indent="1">
                    <SettingItem label="転倒検知及び静止検知">
                        <ToggleSwitch
                            v-model="form.toggle.manDownWithStationary"
                            :disable="!form.toggle.manDownDetection"
                        />
                    </SettingItem>

                    <SettingItem label="転倒検知の角度">
                        <SelectBox
                            :disabled="!form.toggle.manDownDetection"
                            :options="selectboxOptions.manDownAngle"
                            :defaultValue="String(form.selectbox.manDownAngle)"
                            @update="handleSelectBox"
                        />
                    </SettingItem>

                    <SettingItem label="エマージェンシー遅延時間">
                        <ToggleSwitch
                            v-model="form.toggle.manDownDelayTime"
                            :disable="!form.toggle.manDownDetection"
                        />
                        <RangeSlider
                            :inputValue="form.range.manDownDelayTimeValue"
                            @update:inputValue="form.range.manDownDelayTimeValue = $event"
                            :disable="!form.toggle.manDownDelayTime || !form.toggle.manDownDetection"
                            :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MAN_DOWN_DELAY_TIME_VOLUME.MIN"
                            :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MAN_DOWN_DELAY_TIME_VOLUME.MAX"
                            unit="[秒]"
                        />
                    </SettingItem>

                    <SettingItem label="警告トーン出力時間">
                        <ToggleSwitch
                            v-model="form.toggle.manDownPreAlert"
                            :disable="
                                !form.toggle.manDownDetection ||
                                !form.toggle.manDownDelayTime ||
                                form.range.manDownDelayTimeValue <= 1
                            "
                        />
                        <RangeSlider
                            :inputValue="form.range.manDownPreAlertValue"
                            @update:inputValue="form.range.manDownPreAlertValue = $event"
                            :disable="!form.toggle.manDownPreAlert || !form.toggle.manDownDetection"
                            :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MAN_DOWN_PRE_ALERT_VALUE.MIN"
                            :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MAN_DOWN_PRE_ALERT_VALUE.MAX"
                            unit="[秒]"
                        />
                    </SettingItem>
                </SettingGroup>
            </SettingGroup>

            <SettingGroup title="静止検知" :indent="1">
                <template v-slot:title-extra>
                    <span class="title-extra-space">
                        <ToggleSwitch
                            v-model="form.toggle.stationaryDetection"
                            :disable="form.toggle.manDownWithStationary"
                        />
                    </span>
                </template>

                <SettingGroup :indent="1">
                    <SettingItem label="エマージェンシー遅延時間">
                        <ToggleSwitch
                            v-model="form.toggle.stationaryDelayTime"
                            :disable="!form.toggle.stationaryDetection"
                        />
                        <RangeSlider
                            :inputValue="form.range.stationaryDelayTimeValue"
                            @update:inputValue="form.range.stationaryDelayTimeValue = $event"
                            :disable="!form.toggle.stationaryDelayTime || !form.toggle.stationaryDetection"
                            :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.STATIONARY_DELAY_TIME_VOLUME.MIN"
                            :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.STATIONARY_DELAY_TIME_VOLUME.MAX"
                            unit="[秒]"
                        />
                    </SettingItem>

                    <SettingItem label="警告トーン出力時間">
                        <ToggleSwitch
                            v-model="form.toggle.stationaryPreAlert"
                            :disable="
                    !form.toggle.stationaryDetection ||
                    !form.toggle.stationaryDelayTime ||
                    form.range.stationaryDelayTimeValue <= 1
                  "
                        />
                        <RangeSlider
                            :inputValue="form.range.stationaryPreAlertValue"
                            @update:inputValue="form.range.stationaryPreAlertValue = $event"
                            :disable="!form.toggle.stationaryPreAlert || !form.toggle.stationaryDetection"
                            :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.STATIONARY_PRE_ALERT_VALUE.MIN"
                            :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.STATIONARY_PRE_ALERT_VALUE.MAX"
                            unit="[秒]"
                        />
                    </SettingItem>
                </SettingGroup>
            </SettingGroup>

            <SettingGroup title="動き検知" :indent="1">
                <template v-slot:title-extra>
                    <span class="title-extra-space">
                        <ToggleSwitch
                            v-model="form.toggle.motionDetection"
                            :disable="false"
                        />
                    </span>
                </template>

                <SettingGroup :indent="1">
                    <SettingItem label="エマージェンシー遅延時間">
                        <ToggleSwitch
                            v-model="form.toggle.motionDelayTime"
                            :disable="!form.toggle.motionDetection"
                        />
                        <RangeSlider
                            :inputValue="form.range.motionDelayTimeValue"
                            @update:inputValue="form.range.motionDelayTimeValue = $event"
                            :disable="!form.toggle.motionDelayTime || !form.toggle.motionDetection"
                            :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MOTION_DELAY_TIME_VOLUME.MIN"
                            :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MOTION_DELAY_TIME_VOLUME.MAX"
                            unit="[秒]"
                        />
                    </SettingItem>

                    <SettingItem label="警告トーン出力時間">
                        <ToggleSwitch
                            v-model="form.toggle.motionPreAlert"
                            :disable="
                                !form.toggle.motionDetection ||
                                !form.toggle.motionDelayTime ||
                                form.range.motionDelayTimeValue <= 1
                            "
                        />
                        <RangeSlider
                            :inputValue="form.range.motionPreAlertValue"
                            @update:inputValue="form.range.motionPreAlertValue = $event"
                            :disable="!form.toggle.motionPreAlert || !form.toggle.motionDetection"
                            :minLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MOTION_PRE_ALERT_VALUE.MIN"
                            :maxLimit="BC.EMERGENCY_INFORMATION.EMERGENCY.EMERGENCY_DETECTION.MOTION_PRE_ALERT_VALUE.MAX"
                            unit="[秒]"
                        />
                    </SettingItem>
                </SettingGroup>
            </SettingGroup>
        </SettingGroup>
    </div>
</template>

<style scoped>
.title-extra-space {
    margin-left: 5px;
    display: inline-flex;
    align-items: center;
}
</style>
